import object from 'helpers/object'


export const initialState = {
  labels: [],
  schedule: [],
  isFetching: true,
}


export const setLabels = (state, payload) => (
  object.setIn(
    state,
    [ 'labels' ],
    payload
    // payload.sort((a, b) => (
    //   a.lbl > b.lbl
    //     ? 1
    //     : a.lbl < b.lbl
    //     ? -1
    //     : 0
    // ))
  )
)

export const setSchedule = (state, payload) => (
  object.setIn(state, [ 'schedule' ], state.schedule.concat(payload))
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
